<template>
  <!-- "Exercicios desta aula" (card 17trt6jcyfb). Some quando a aula nao tem
       questionario vinculado. Retorno de 16/10: ocupa a largura toda, abre e
       fecha (comeca fechado, como as anotacoes) e agrupa por secao
       (Exercises, Listening, Create and Translate, Reading). -->
  <section
    v-if="sets.length"
    class="lex"
    :class="[`lex--${profile}`, { 'is-open': open }]"
  >
    <button
      type="button"
      class="lex__toggle"
      :aria-expanded="String(open)"
      aria-controls="lex-body"
      @click="open = !open"
    >
      <span class="lex__title">
        <i class="mdi mdi-pencil-outline" aria-hidden="true"></i>
        {{ $t("exercises.lessonTitle") }}
      </span>
      <span class="lex__progress">
        {{
          $t("exercises.progress", { done: finishedCount, total: totalCount })
        }}
      </span>
      <i
        class="mdi lex__chev"
        :class="open ? 'mdi-chevron-up' : 'mdi-chevron-down'"
        aria-hidden="true"
      ></i>
    </button>

    <div v-show="open" id="lex-body" class="lex__body">
      <p class="lex__hint">
        {{
          $t(
            profile === "partner"
              ? "exercises.trainingHint"
              : "exercises.lessonHint"
          )
        }}
      </p>

      <div v-for="group in sections" :key="group.section" class="lex__section">
        <p class="lex__setname">{{ sectionLabel(group.section) }}</p>
        <router-link
          v-for="exercise in group.exercises"
          :key="exercise.id"
          :to="exerciseLink(exercise.id)"
          class="lex__row"
        >
          <span
            class="lex__check"
            :class="{ 'is-done': exercise.status === 'FINISHED' }"
            role="img"
            :aria-label="
              exercise.status === 'FINISHED'
                ? $t('exercises.finished')
                : $t('exercises.notFinished')
            "
          >
            <i
              v-if="exercise.status === 'FINISHED'"
              class="mdi mdi-check"
              aria-hidden="true"
            ></i>
          </span>
          <span class="lex__info">
            <span class="lex__prompt">{{
              exercise.prompt || $t("exercises.exercise")
            }}</span>
            <span class="lex__meta">
              {{
                $tc("exercises.questions", exercise.itemCount, {
                  count: exercise.itemCount,
                })
              }}
              <span v-if="exercise.reviewedAt" class="lex__reviewed">
                · {{ $t("exercises.reviewedByTeacher") }}
              </span>
            </span>
          </span>
          <span class="lex__state" :class="`lex__state--${exercise.status}`">
            <template v-if="exercise.status === 'FINISHED'">
              <b>{{ exercise.correctItems }}/{{ exercise.totalItems }}</b>
            </template>
            <template v-else-if="exercise.status === 'IN_PROGRESS'">
              {{ $t("common.continue") }}
            </template>
            <template v-else>{{ $t("exercises.do") }}</template>
          </span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import customerApi from "@/shared/pitchCustomerApi";
import partnerApi from "@/shared/pitchPartnerApi";

export default {
  name: "LessonExercises",
  props: {
    courseClassId: { type: String, required: true },
    // customer: aula do aluno. partner: treinamento do professor (retorno de
    // 22/10), em que ele faz o exercício como o aluno.
    profile: { type: String, default: "customer" },
  },
  data() {
    return { sets: [], open: false };
  },
  computed: {
    // A API ja devolve na ordem das secoes; aqui so junta os questionarios
    // da mesma secao.
    sections() {
      const groups = [];
      for (const set of this.sets) {
        const section = set.section || "EXERCISES";
        let group = groups.find((item) => item.section === section);
        if (!group) {
          group = { section, exercises: [] };
          groups.push(group);
        }
        group.exercises.push(...set.exercises);
      }
      return groups;
    },
    totalCount() {
      return this.sets.reduce((sum, set) => sum + set.exercises.length, 0);
    },
    finishedCount() {
      return this.sets.reduce(
        (sum, set) =>
          sum + set.exercises.filter((e) => e.status === "FINISHED").length,
        0
      );
    },
  },
  methods: {
    exerciseLink(id) {
      return this.profile === "partner"
        ? `/connect/professor/exercicios/treinamento/${id}`
        : `/connect/aluno/exercicios/${id}`;
    },
    sectionLabel(section) {
      const key = `exercises.sections.${section}`;
      return this.$te(key) ? this.$t(key) : section;
    },
  },
  watch: {
    courseClassId: {
      immediate: true,
      handler(id) {
        if (!id) return;
        (this.profile === "partner"
          ? partnerApi.listTrainingExercises(id)
          : customerApi.listLessonExercises(id)
        )
          .then((res) => {
            this.sets = (res.data?.data || []).filter(
              (set) => set.exercises.length
            );
          })
          // Sem exercicios, a aula segue normal: o bloco so nao aparece.
          .catch(() => {
            this.sets = [];
          });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
/* Retorno de 16/10: o exercicio e do aluno, entao segue a paleta do aluno
   (rosa); so a nota, que e a "caneta do professor", fica em roxo. */
.lex {
  --accent: var(--dk-pink, #e8276f);
  --accent-wash: var(--dk-pink-wash, #fdeef4);
  --pen: var(--dk-grape, #a826e1);

  grid-column: 1 / -1;
  border-radius: 16px;
  background: var(--dk-surface, #fff);
  border: 1px solid var(--dk-line, #ece6f5);
}

/* Treinamento: o professor responde, na paleta dele (roxo). */
.lex--partner {
  --accent: var(--dk-grape, #a826e1);
  --accent-wash: var(--dk-grape-wash, #f4e9fb);
  margin-top: 16px;
}

.lex__toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 16px 20px;
  border: 0;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.lex__toggle:focus-visible {
  outline: 3px solid rgba(232, 39, 111, 0.3);
  outline-offset: -3px;
  border-radius: 16px;
}

.lex__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--dk-ink, #2b2540);
}

.lex__title .mdi {
  color: var(--accent);
}

.lex__progress {
  margin-left: auto;
  font-size: 13px;
  color: var(--dk-muted, #7a7590);
}

.lex__chev {
  font-size: 22px;
  color: var(--dk-muted, #7a7590);
}

.lex__body {
  padding: 0 20px 8px;
}

.lex__hint {
  margin: 0 0 6px;
  font-size: 13px;
  color: var(--dk-muted, #7a7590);
}

.lex__reviewed {
  color: var(--dk-teal, #00a379);
}

.lex__setname {
  margin: 12px 0 0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--accent);
}

.lex__row {
  display: grid;
  grid-template-columns: 32px 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px dashed var(--dk-line, #ece6f5);
  text-decoration: none;
  color: inherit;
}

.lex__row:first-of-type {
  border-top: 0;
}

.lex__row:hover .lex__prompt,
.lex__row:focus-visible .lex__prompt {
  color: var(--accent);
}

.lex__row:focus-visible {
  outline: 3px solid rgba(232, 39, 111, 0.3);
  outline-offset: 2px;
  border-radius: 8px;
}

/* Retorno de 16/10: no lugar do numero, uma caixinha que ganha o check
   quando o exercicio e finalizado. */
.lex__check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
  width: 22px;
  height: 22px;
  border: 2px solid var(--dk-line-strong, #d6cfe2);
  border-radius: 6px;
  background: var(--dk-surface, #fff);
  color: #fff;
}

.lex__check.is-done {
  border-color: var(--accent);
  background: var(--accent);
}

.lex__check .mdi {
  font-size: 16px;
  line-height: 1;
}

.lex__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.lex__prompt {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14.5px;
  font-weight: 600;
  color: var(--dk-ink, #2b2540);
  transition: color 0.15s ease;
}

.lex__meta {
  font-size: 12.5px;
  color: var(--dk-muted, #7a7590);
}

.lex__state {
  padding: 4px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.lex__state--NOT_STARTED {
  background: var(--accent);
  color: #fff;
}

.lex__state--IN_PROGRESS {
  background: var(--accent-wash);
  color: var(--accent);
}

/* A nota, no idioma da folha corrigida. */
.lex__state--FINISHED {
  padding: 0 6px;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: var(--pen);
}
</style>
